import { render, staticRenderFns } from "./TestStart.vue?vue&type=template&id=d6bc1b7a&"
import script from "./TestStart.vue?vue&type=script&lang=js&"
export * from "./TestStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports